import React from 'react';
import { Bell, ChevronRight } from 'lucide-react';

function timeAgo(d) {
  if (!d) return '';
  const mins = Math.floor((Date.now() - new Date(d).getTime()) / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

function truncate(s, n) {
  if (!s) return '';
  return s.length > n ? s.slice(0, n) + '…' : s;
}

export default function MentionsSection({ rows, count, onSeeAll, onRowClick }) {
  const visible = (rows || []).slice(0, 5);

  if (!visible.length) {
    return (
      <div className="my-day-card">
        <SectionHeader count={count} />
        <p style={{ fontSize: 12, color: '#6C757D', margin: '12px 0 0', textAlign: 'center' }}>No new mentions this week.</p>
      </div>
    );
  }

  return (
    <div className="my-day-card">
      <SectionHeader count={count} />
      <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {visible.map(m => {
          const contact = [m.first_name, m.last_name].filter(Boolean).join(' ') || 'Contact';
          const clickable = onRowClick && m.contact_id;
          return (
            <div
              key={m.id}
              className={clickable ? 'my-day-row-clickable' : ''}
              onClick={clickable ? () => onRowClick(m) : undefined}
              role={clickable ? 'button' : undefined}
              tabIndex={clickable ? 0 : undefined}
              onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRowClick(m); } } : undefined}
              style={{ background: '#F8F9FA', borderRadius: 10, padding: '8px 12px', boxShadow: '2px 2px 5px rgba(186,199,216,0.35), -2px -2px 5px rgba(255,255,255,0.8)' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 4 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: '#2E8B98' }}>{m.author_name || 'Someone'}</span>
                <span style={{ fontSize: 10, color: '#ADB5BD' }}>{timeAgo(m.created_at)}</span>
              </div>
              <div style={{ fontSize: 12, color: '#495057', lineHeight: 1.4 }}>{truncate(m.body, 100)}</div>
              {m.contact_id && (
                <div style={{ fontSize: 11, color: '#ADB5BD', marginTop: 4 }}>
                  re: {contact}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {onSeeAll && <SeeAllLink onSeeAll={onSeeAll} />}
    </div>
  );
}

function SectionHeader({ count }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
      <Bell size={15} color="#2E8B98" />
      <span style={{ fontSize: 13, fontWeight: 700, color: '#212529' }}>Mentions</span>
      {count > 0 && <span className="my-day-count-badge active">{count}</span>}
      {count === 0 && <span className="my-day-count-badge">0</span>}
    </div>
  );
}

function SeeAllLink({ onSeeAll }) {
  return (
    <button onClick={onSeeAll} style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 10, background: 'none', border: 'none', color: '#2E8B98', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
      See all <ChevronRight size={13} />
    </button>
  );
}
